const FormDefaultData = {
  age: 0,
  dob: "",
  full_name: "",
  zip_code: "12005",
  own_house: false,
  adult_in_household: 2,
  children_in_house: 1,
  household_health: "ALL",
  industry_employed_in: "financials",
  annual_income: 100000,
  annual_expenses: 75000,
  net_worth: 250000,
  income_consistency: "guaranteed",
  investment_amount: 300000,
  investment_period: 10,
  max_loss: 10000,
};

export default FormDefaultData;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/formDefaultData.js